import { Typography } from '@mui/material';
import MyTagsLogo from 'components/svg-assets/MyTagsLogo';
import Link from 'next/link';
import styles from './AuthFlowPageWrapper.module.scss'

export default function AuthFlowPageWrapper ({ children, asideContent = '' }) {

  return (
    <div className={styles.pageWrapper}>
      <div className={`${styles.container} ${styles.contentWrapper}`}>
        <main className={styles.mainContentWrapper}>
          <header className={styles.pageHeader}>
          <div className={styles.logoSection}>
            <Link href='/'>
              <span className={styles.logoSpan}>
                <MyTagsLogo />
              </span>
            </Link>
          </div>
          </header>
          <div className={styles.pageContent}>
            {children}
          </div>
          <footer className={styles.pageFooter}>
            <nav className={styles.footerNav}>
              <ul>
                <li>
                  <Link href="/">Homepage</Link>
                </li>
                <li>
                  <Link href="/terms-of-service">Terms of Service</Link>
                </li>
                <li>
                  <Link href="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link href="#">Contact</Link>
                </li>
              </ul>
            </nav>
            <div className={styles.copyright}>
              <Typography variant='body2' color='text.hint' sx={{ mb: 0.5 }}>
                Copyright @{new Date().getFullYear()} MyTags
              </Typography>
              <Typography variant='body2' color='text.hint'>
                An INITEQ ♥ BytePanda Product
              </Typography>
            </div>
          </footer>
        </main>
        <aside className={styles.asideContent}>
          {asideContent}
        </aside>
      </div>
    </div>
  )
}
